<p class="d-none">Kachiing Community</p>
<app-filter-products #MemberShopProduct (onChangeEvent)="onMemberShopProductChange($event)">
</app-filter-products>

<community-articles #Articles></community-articles>